import { useState } from "react";
import type { MediaItem } from "@/types/media";
import MovieCard from "@/components/feature/MovieCard";
import SectionTitle from "@/components/base/SectionTitle";

const PAGE_SIZE = 8;

export default function LatestResources({ items }: { items: MediaItem[] }) {
  const [page, setPage] = useState(1);
  const totalPages = Math.max(1, Math.ceil(items.length / PAGE_SIZE));
  const start = (page - 1) * PAGE_SIZE;
  const pageItems = items.slice(start, start + PAGE_SIZE);

  return (
    <div>
      <SectionTitle
        icon="ri-time-line"
        title="最新影视资源"
        subtitle="按更新时间排序，发现刚上线的热门作品"
      />

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
        {pageItems.map((item) => (
          <MovieCard key={item.id} item={item} />
        ))}
      </div>

      {totalPages > 1 ? (
        <div className="mt-8 flex items-center justify-center gap-2 flex-wrap">
          <button
            type="button"
            disabled={page === 1}
            onClick={() => setPage((p) => Math.max(1, p - 1))}
            className="h-9 px-3 rounded-md border border-background-300 text-sm text-foreground-700 disabled:opacity-40 disabled:cursor-not-allowed hover:border-primary-400 transition-colors cursor-pointer whitespace-nowrap"
          >
            上一页
          </button>
          {Array.from({ length: totalPages }, (_, i) => i + 1).map((n) => (
            <button
              key={n}
              type="button"
              onClick={() => setPage(n)}
              className={`w-9 h-9 rounded-md text-sm transition-colors cursor-pointer ${
                n === page
                  ? "bg-primary-500 text-background-50"
                  : "border border-background-300 text-foreground-700 hover:border-primary-400"
              }`}
            >
              {n}
            </button>
          ))}
          <button
            type="button"
            disabled={page === totalPages}
            onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
            className="h-9 px-3 rounded-md border border-background-300 text-sm text-foreground-700 disabled:opacity-40 disabled:cursor-not-allowed hover:border-primary-400 transition-colors cursor-pointer whitespace-nowrap"
          >
            下一页
          </button>
        </div>
      ) : null}
    </div>
  );
}